import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=684e52cb&scoped=true&"
import script from "./Loan.vue?vue&type=script&lang=js&"
export * from "./Loan.vue?vue&type=script&lang=js&"
import style0 from "./Loan.vue?vue&type=style&index=0&id=684e52cb&lang=scss&scoped=true&"
import style1 from "./Loan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e52cb",
  null
  
)

export default component.exports